import * as React from 'react';
const SvgLink = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M6.032 13.616q-1.5 0-2.558-1.06a3.5 3.5 0 0 1-1.057-2.56q0-1.503 1.057-2.557a3.5 3.5 0 0 1 2.558-1.054h2.266q.23 0 .386.154.156.155.156.383a.53.53 0 0 1-.156.388.52.52 0 0 1-.386.158H6.031q-1.049 0-1.79.741A2.44 2.44 0 0 0 3.501 10q0 1.05.74 1.791.741.741 1.79.741h2.267q.23 0 .386.155.156.154.156.383a.53.53 0 0 1-.156.387.52.52 0 0 1-.386.159zm1.724-3.074a.536.536 0 0 1-.548-.538q0-.228.156-.387a.52.52 0 0 1 .385-.158h4.495a.536.536 0 0 1 .548.537.53.53 0 0 1-.156.387.52.52 0 0 1-.385.159zm3.946 3.074a.53.53 0 0 1-.386-.155.52.52 0 0 1-.156-.383q0-.228.156-.387a.52.52 0 0 1 .386-.159h2.267q1.05 0 1.79-.741a2.44 2.44 0 0 0 .741-1.79q0-1.05-.741-1.792a2.44 2.44 0 0 0-1.79-.74h-2.267a.53.53 0 0 1-.386-.155.52.52 0 0 1-.156-.383q0-.23.156-.387a.52.52 0 0 1 .386-.16h2.266q1.5 0 2.558 1.06a3.5 3.5 0 0 1 1.057 2.56q0 1.503-1.057 2.557a3.5 3.5 0 0 1-2.558 1.055z'
            />
        </g>
    </svg>
);
export default SvgLink;
